import {defineStore} from "pinia";
import {type RemovableRef, useStorage} from "@vueuse/core";
import {getRouting} from "@/services/transport/transport-service";
import {DefaultTransportRoutingModel, type TransportRoutingModel} from "@/models/transport/routing";
import type { GroupedTransportAction } from '@/models/transport/transport-action';

interface TransportRoutingState {
    loading: boolean;
    editMode: boolean;
    activeRoutingTab: RemovableRef<string>;
    routing: TransportRoutingModel;
    groupedActions: GroupedTransportAction[];
}

export class TransportRoutes {
    static TrajectoriesTab = "trajectories";
    static DestinationsTab = "destinations";
    static StatusHistoryTab = "statusHistory";
}

export const useTransportRoutingStore = defineStore({
    id: 'transport-routing',
    state: () => ({
        loading: false,
        editMode: false,
        activeRoutingTab: useStorage("transport-active-routing-tab", TransportRoutes.TrajectoriesTab),
        routing: DefaultTransportRoutingModel(),
        groupedActions: [],
    } as TransportRoutingState),
    actions: {
        async getRouting(transportId: number) {
            this.loading = true;
            this.routing = DefaultTransportRoutingModel();

            const response = await getRouting(transportId)
            if (response.status === 200) {
                this.routing = response.data;
            }

            this.loading = false;
        },
        updateAfterAdjustingActionSequence() {
            this.routing.actions.forEach((action) => {
                action.distance = null;
                action.drivingTime = null;
                action.duration = null;
            });

            this.routing.hasRoute = false;
            this.routing.polyLine = null;
            this.routing.totalDistance = null;
            this.routing.totalDuration = null;
        }
    }
})
